import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { orpc } from '@/lib/api/orpc';
import { SearchSchema } from './-zod-schema';

// タブのカテゴリ別件数（oRPC: alumni.count → GET /v2/alumnus/count）。
// 総数表示のためフィルタは渡さない（従来の REST loader と同じ挙動）。
export const Route = createFileRoute('/_staff/people/_list/alumni/')({
  validateSearch: zodValidator(SearchSchema),
  loader: () => orpc.alumni.count.call({})
});